import {
  Facebook, Instagram, LinkedIn, Reddit, StorefrontRounded, Telegram, Twitter, YouTube,
} from '@mui/icons-material'
import {
  Grid, Stack, Typography, useTheme,
} from '@mui/material'
import type { FlexBoxProps } from '@xylabs/react-flexbox'
import { FlexCol, FlexRow } from '@xylabs/react-flexbox'
import { LinkEx } from '@xylabs/react-link'
import type { ReactNode } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaDiscord } from 'react-icons/fa'

import { Images } from '../../img/index.ts'
import { fastHash } from '../../lib/fastHash.ts'
import { RotationAnimation } from '../AnimatedComponents/index.ts'

interface SocialLinksDataProps {
  icon: ReactNode
  link: string
}

const socialLinksData: SocialLinksDataProps[] = [
  { icon: <Facebook style={{ fontSize: '24px' }} />, link: 'https://www.facebook.com/OfficialXYO' },
  { icon: <Twitter style={{ fontSize: '24px' }} />, link: 'https://twitter.com/OfficialXYO' },
  { icon: <Instagram style={{ fontSize: '24px' }} />, link: 'https://www.instagram.com/officialxyo/' },
  { icon: <Telegram style={{ fontSize: '24px' }} />, link: 'https://t.me/official_xyo' },
  { icon: <Reddit style={{ fontSize: '24px' }} />, link: 'https://www.reddit.com/r/XYONetwork/' },
  { icon: <YouTube style={{ fontSize: '24px' }} />, link: 'https://www.youtube.com/channel/UCyZDqb9pgntVHJVt1pxXtsw' },
  { icon: <LinkedIn style={{ fontSize: '24px' }} />, link: 'https://www.linkedin.com/company/officialxyo/' },
  { icon: <FaDiscord style={{ fontSize: '24px' }} />, link: 'https://discord.gg/officialxyo' },
  { icon: <StorefrontRounded style={{ fontSize: '24px' }} />, link: 'https://shop.xyo.network' },
]

export const SocialFooterLinks: React.FC<FlexBoxProps> = (props) => {
  const theme = useTheme()

  const { t } = useTranslation()
  return (
    <FlexCol sx={{ alignItems: { md: 'flex-start', xs: 'center' } }} {...props}>
      <LinkEx to="/" marginBottom={2}>
        <Stack direction="row" paddingRight={1} spacing={0.5} alignItems="center" justifyContent="center">
          <RotationAnimation rotation={20}>
            <img src={Images.Logos.XYOIconWhite} height={32} />
          </RotationAnimation>
          <img src={Images.Logos.XYOTextWhite} height={25} />
        </Stack>
      </LinkEx>
      <Typography fontWeight={500} variant="h6" sx={{ color: theme.vars.palette.primary.contrastText }}>
        {t('footer:links.socials.title')}
      </Typography>
      <Grid container sx={{ justifyContent: { md: 'flex-start', xs: 'center' } }} spacing={2} paddingTop={1.5}>
        {socialLinksData.map((social) => {
          return (
            <Grid
              key={fastHash(social.link)}
              size={{
                xs: 3, sm: 1, md: 4,
              }}
            >
              <FlexRow sx={{ alignItems: { md: 'flex-start', xs: 'center' }, justifyContent: { md: 'flex-start', xs: 'center' } }}>
                <RotationAnimation rotation={20}>
                  <LinkEx sx={{ color: theme.vars.palette.primary.contrastText }} href={social.link}>
                    {social.icon}
                  </LinkEx>
                </RotationAnimation>
              </FlexRow>
            </Grid>
          )
        })}
      </Grid>
    </FlexCol>
  )
}
